import { makeStyles } from "@material-ui/core/styles";
import { Box, Grid, Tooltip, Typography } from "@mui/material";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as FilterIcon } from "../../assets/Customer/FilterIcon.svg";
import { ReactComponent as FilterIconHover } from "../../assets/Customer/FilterIconHover.svg";
import CustomTextfield from "../../components/CustomInputs/CustomTextfield";
import DialogBox from "../../components/DialogBoxComponent/DialogBox";
import Toast from "../../components/ToastContainer/CustomToast";
import { ThemeContext } from "../../theme/ThemeContext";

const useStyles = makeStyles((theme) => ({
  textarea: {
    resize: "both",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
    background: "#3d4977",
    width: "100%",
    padding: "5px",
    textAlign: "center",
    borderRadius: "5px",
    color: "#FFFFFF",
  },
  dialogbox: {
    "& .MuiDialog-paper": {
      // minWidth: '110vh',
      maxWidth: "600px",
      // marginLeft: "250px",
      borderRadius: "20px",
      backgroundColor: (props) => (props.darkMode ? "#0E2A41" : "#fff"),
    },
  },
}));

export default function FilterDevice(props) {
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const classes = useStyles({ darkMode });
  const defaultFilter = {
    deviceAlias: "",
    deviceSn: "",
    deviceType: "",
  };
  const [filterQuery, setFilterQuery] = useState({ ...defaultFilter });
  const [isHovered, setIsHovered] = useState(false);
  const handleChange = (event) => {
    const name = event.target.name;
    setFilterQuery({
      ...filterQuery,
      [name]: event.target.value,
    });
  };

  const handleClose = () => {
    setFilterQuery(defaultFilter);
    setOpen(false);
    setDiaLogBoxBlur(false);
  };

  if (open) {
    setDiaLogBoxBlur(true);
  }

  const handleSubmit = () => {
    if (
      filterQuery.deviceAlias.trim() === "" &&
      filterQuery.deviceSn.trim() === "" &&
      filterQuery.deviceType.trim() === ""
    ) {
      Toast(t("COMMON154"), "error");
      return;
    }

    props.onSubmit(filterQuery);
    handleClose();
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const reset = () => {
    // if(filterQuery.deviceAlias.trim() === "" && filterQuery.deviceSn.trim() === "" && filterQuery.deviceType.trim() === ""){
    //     Toast(t("Nothing to Reset"), "error");
    //     return;
    // }
    // setFilterQuery(defaultFilter);
    setOpen(false);
  };

  return (
    <>
      <Tooltip
        title={
          <Typography fontSize={12} fontWeight={500}>
            {t("COMMON006")}
          </Typography>
        }
      >
        <span
          className={darkMode ? "filterdark" : "filter"}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={handleOpen}
        >
          {isHovered ? (
            <FilterIconHover
              style={{
                cursor: "pointer",
                color: darkMode ? "#fff" : "#474a4e",
              }}
            >
              <FilterDevice />
            </FilterIconHover>
          ) : (
            <FilterIcon
              style={{
                cursor: "pointer",
                color: darkMode ? "#fff" : "#474a4e",
              }}
            >
              <FilterDevice />
            </FilterIcon>
          )}
        </span>
      </Tooltip>

      <DialogBox
        Header={
          <span style={{ fontSize: "21px", color: darkMode ? "#fff" : "" }}>
            {t("COMMON006")}
          </span>
        }
        className={classes.dialogbox}
        acceptText={t("COMMON024")}
        cancelText={t("COMMON008")}
        fullWidth={true}
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmit}
        cancel={handleClose}
      >
        <Grid
          container
          rowSpacing={2}
          style={{ backgroundColor: darkMode ? "#0E2A41" : "" }}
        >
          <Grid item xs={12} sm={12}>
            <CustomTextfield
              inputProps={{ className: classes.textarea }}
              label={t("VISACCDEV002")}
              name="deviceAlias"
              value={filterQuery.deviceAlias}
              handleChange={(e) => handleChange(e)}
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <CustomTextfield
              inputProps={{ className: classes.textarea }}
              label={t("ACCDEV002")}
              name="deviceSn"
              value={filterQuery.deviceSn}
              handleChange={(e) => handleChange(e)}
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <CustomTextfield
              inputProps={{ className: classes.textarea }}
              label={t("DEVICE_TYPE_HEADER")}
              name="deviceType"
              value={filterQuery.deviceType}
              handleChange={(e) => handleChange(e)}
            />
          </Grid>
        </Grid>
      </DialogBox>
    </>
  );
}
